.container {
    box-sizing: border-box;
    min-width: 448px;
    background-color: var(--white);
    padding: 8px 16px;
    border-radius: 3px;
}
